import { render, staticRenderFns } from "./UserMobile.vue?vue&type=template&id=53048a95&scoped=true"
import script from "./UserMobile.vue?vue&type=script&lang=js"
export * from "./UserMobile.vue?vue&type=script&lang=js"
import style0 from "./UserMobile.vue?vue&type=style&index=0&id=53048a95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53048a95",
  null
  
)

export default component.exports